import styled from 'styled-components'
import { colors } from './theme'
import { common, TextProps } from './types'
import { mobile } from './media'

export const H1 = styled.h1<TextProps>`
  font-weight: bold;
  font-size: 24px;
  line-height: 28px;
  text-align: center;

  @media ${mobile} {
    font-size: 18px;
    line-height: 21px;
  }

  ${common}
`

export const P = styled.p<TextProps>`
  font-size: 18px;
  line-height: 21px;
  color: black;
  text-align: center;

  @media ${mobile} {
    font-size: 14px;
    line-height: 16px;
  }

  ${common}
`

export const Tag = styled.p<TextProps>`
  font-size: 18px;
  line-height: 21px;
  color: ${colors.lgRed};
  text-align: center;

  @media ${mobile} {
    font-size: 16px;
    line-height: 19px;
  }

  ${common}
`

export const Terms = styled(P)<TextProps>`
  font-size: 12px;
  line-height: 14px;

  @media ${mobile} {
    font-size: 10px;
    line-height: 12px;
  }
`

export const MobileBR = styled.br`
  display: none;

  @media ${mobile} {
    display: unset;
  }
`

export const DesktopBR = styled.br`
  @media ${mobile} {
    display: none;
  }
`
